const en = {
  meta: {
    title: "OnHuman.tech — engineering the software human work runs on",
  },
  brand: {
    name: "OnHuman Technology",
    tagline: "Engineering the future of human-centric software",
    hrLinkLabel: "OnHuman HR",
  },
  nav: {
    capabilities: "Capabilities",
    process: "Process",
    domains: "Domains",
    contact: "Contact us",
  },
  hero: {
    title: ["Engineered for", "human work."],
    cta: "Start a project",
  },
  capabilities: {
    title: ["Four disciplines,", "one studio."],
    lede:
      "Independent modules, end-to-end products or bespoke integrations, delivered on the platform that fits the problem. Pick a discipline to see what we build.",
    listLabel: "Disciplines",
    builtWith: "Built with",
    youGet: "What you get",
    items: [
      {
        key: "mobile",
        word: "Mobile",
        title: "Mobile apps",
        desc: "Native and React Native applications for iOS and Android. Offline-first, secure storage, and a build pipeline you can ship from.",
        stack: ["iOS", "Android", "React Native"],
        deliverable: "A store-ready app with a release pipeline you can run yourself.",
      },
      {
        key: "desktop",
        word: "Desktop",
        title: "Desktop software",
        desc: "Windows and cross-platform desktop software. Electron, .NET, and native Win32 where it earns its place.",
        stack: ["Windows", "macOS", "Electron", ".NET"],
        deliverable: "A signed installer with auto-update, for Windows and macOS.",
      },
      {
        key: "web",
        word: "Web",
        title: "Web applications",
        desc: "Modern web applications, internal tools and dashboards. Type-safe, accessible, designed around how the work actually flows.",
        stack: ["React", "Next.js", "Node", "PostgreSQL"],
        deliverable: "A deployed application with a design system, tests and continuous delivery.",
      },
      {
        key: "ai",
        word: "AI",
        title: "AI and automation",
        desc: "LLM integrations, document intelligence and workflow automation. Practical AI, measured in hours saved per week.",
        stack: ["OpenAI", "Anthropic", "Python"],
        deliverable: "An automation that removes a weekly chore, with the numbers to prove it.",
      },
    ],
  },
  process: {
    title: ["From ambiguity", "to a shipped product."],
    lede: "Four stages with a clear hand-off between each. You always know where the work stands.",
    steps: [
      {
        n: "01",
        title: "Discover",
        desc: "Map the problem space, the stakeholders and the constraints before a single line of code.",
      },
      {
        n: "02",
        title: "Design",
        desc: "Architecture, data models and the user flows, reviewed and de-risked in parallel.",
      },
      {
        n: "03",
        title: "Build",
        desc: "Short iterations, continuous delivery and instrumentation from day one.",
      },
      {
        n: "04",
        title: "Operate",
        desc: "We hand over a system you can run, with observability, documentation and training.",
      },
    ],
  },
  domains: {
    title: ["Born in HR.", "Useful everywhere."],
    lede:
      "OnHuman Technology grew out of OnHuman HR's own operations. Today we build for HR, recruitment and the adjacent teams that touch people at work.",
    items: [
      { title: "Human resources", desc: "Core HR operations, workforce planning and people strategy." },
      { title: "Recruitment", desc: "Talent acquisition, candidate pipelines and hiring workflows." },
      { title: "Workforce analytics", desc: "Data-driven insight into headcount, retention and performance." },
      { title: "Learning and development", desc: "Training programs, skills tracking and career paths." },
      { title: "Compliance", desc: "Regulatory adherence, policy management and audit readiness." },
      { title: "Internal tooling", desc: "Custom tools for operations, reporting and cross-team workflows." },
    ],
  },
  cta: {
    title: ["Got an idea?", "Let's build it."],
    lede: "Tell us what you're trying to build. We'll come back with a plan, a stack and a realistic timeline.",
    button: "Email us",
    email: "contact@onhumanresources.com",
    note: "Based in Istanbul, working anywhere.",
  },
  footer: {
    blurb: "A small studio engineering mobile, desktop, web and AI systems for the people who keep work moving.",
    emailLabel: "Email",
    rights: "All rights reserved.",
    location: "Istanbul, Turkey",
  },
};

export default en;
